import React, {useEffect, useState} from "react";

import ExperienceMember from './ExperienceMember';
import FavoriteItem from './FavoriteItem';
import {useTranslation} from "react-i18next";

export default function ProMember(props) {

    const {t, i18n} = useTranslation();

    const profileLink = () => {
        if (window.win_language_code !== 'en') {
            return '/' + window.win_language_code + props.hit.directory_link
        }
        return props.hit.directory_link
    }

    return (
        <div className="individuals__item">
            <div className="individual">
                <div className="individual__inner">
                    <figure>
                        <img src={props.hit.directory_image} alt=""/>
                    </figure>

                    <div className="individual__content">
                        <div className="individual__head">
                            <h4>{props.hit.name}</h4>

                            <span>• {props.hit.directory_location}</span>
                        </div>

                        <div className="individual__title">
                            <p>{props.hit.directory_job}</p>
                        </div>
                    </div>
                </div>

                <aside className="individual__aside">

                    <ExperienceMember hit={props.hit}/>


                    <div className="individual__actions">
                        <a href={profileLink()} className="btn btn--outline">
                            {t('Directory.ViewPro')}
                        </a>
                        <FavoriteItem item={props.hit}/>
                    </div>
                </aside>
            </div>
        </div>
    );
}
